var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18051 17.6405C7.57372 15.629 4 10.7539 4 8.01557C4 4.69322 6.64597 2 9.91003 2C13.1729 2 15.8201 4.69322 15.8201 8.01557C15.8201 10.7539 12.2186 15.629 10.6396 17.6405C10.2609 18.1198 9.55912 18.1198 9.18051 17.6405ZM9.91003 10.0208C10.9966 10.0208 11.88 9.12155 11.88 8.01557C11.88 6.90958 10.9966 6.01038 9.91003 6.01038C8.82345 6.01038 7.94002 6.90958 7.94002 8.01557C7.94002 9.12155 8.82345 10.0208 9.91003 10.0208Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.249ffe0009a7adac4147aa3eda50ee7a.svg";
export { ForwardRef as ReactComponent };